module.exports = __webpack_public_path__ + "media/images/common/nav_separate-f066ed4bae020bbfbf3891f8ee28fee3.gif";